<app-admin-dashboard>
  <div class="header-card separator pt-0">
    <div class="field col-12 md:col-6 lg:col-4">
      <label for="profileId" style="font-weight: bolder">
          {{'AdminLoadInvoice.ProfileLabel' | translate}} *
        </label>
        <p-dropdown
          id="profileId"
          [(ngModel)]="profileUsername"
          [options]="profiles"
          optionValue="contactEmail"
          optionLabel="companyName"
          [filter]="true"
          filterBy="companyName"
          [showClear]="true"
          (onChange)="onProfileChange($event.value)"
          placeholder="{{'AdminLoadInvoice.ProfilePlaceholder' | translate}}"
          class="custom-dropdown">
        </p-dropdown>
    </div>
  </div>
  <div class="card">
    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <h1 class="text-xl font-medium text-800 my-0">
          {{ "UserPalletStock.PalletStockImport.TableTitle" | translate }}
        </h1>
      </div>
      <div class="col-9 flex align-items-center justify-content-end flex-wrap gap-2">
        <p-button
          label="{{'UserPalletStock.Refresh' | translate}}"
          icon="pi pi-refresh"
          styleClass="p-button-secondary"
          class="custom-text-button"
          (click)="getLoadProcesses()">
        </p-button>
      </div>
    </div>
    <app-import-processes-table
      [processes]="activeImportProcesses"
      [loading]="loadingProcesses">
    </app-import-processes-table>
  </div>
  <div class="card">
    <div class="header-card separator pt-0">
      <div class="w-3 container-title">
        <h1 class="text-xl font-medium text-800 my-0">{{'UserPalletStock.StockTitle' | translate}}</h1>
      </div>
      <div class="w-9 flex align-items-center justify-content-end flex-wrap gap-2">
        <p-button
          label="{{'UserPalletStock.CreateStockBtn' | translate}}"
          icon="pi pi-plus"
          class="custom-text-button"
          (click)="onVisibleCreateStock()">
        </p-button>
        <p-button
          label="{{'UserPalletStock.CreateFormatBtn' | translate}}"
          icon="pi pi-plus"
          styleClass="p-button-secondary"
          class="custom-text-button"
          (click)="onVisibleCreateFormatPalletStock()">
        </p-button>
      </div>
    </div>
    <app-stocks-table
      [stocks]="stocks"
      [loading]="loading"
      [pageSize]="pageSize"
      [totalCount]="totalCount"
      (lazyLoad)="getStocksPaged($event)"
      (viewStock)="onViewStock($event)"
      (viewRules)="onViewRules($event)"
      (viewAlert)="showStockAlert($event)"
      (configureQuarter)="showQuarterConfig($event)"
      (createProgram)="showProgramFromStock($event)">
    </app-stocks-table>
  </div>
</app-admin-dashboard>

<p-confirmDialog acceptLabel="{{'UserPages.UserFridgestorages.FridgestorageTable.YesLabel' | translate}}" rejectLabel="{{'UserPages.UserFridgestorages.FridgestorageTable.NotLabel' | translate}}" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>

<p-dialog
  [header]="isEdit ? ('UserPalletStock.EditStockDialog' | translate) : ('UserPalletStock.CreateStockDialog' | translate)"
  [(visible)]="visibleCreateStock"
  [style]="{width: '60%'}"
  [modal]="true"
  (onHide)="onCloseFileFormat()"
  class="stock-dialog">
  <p *ngIf="isEdit" class="font-8rem text-gray-600 line-height-2 mt-0 mb-5">
    * {{'UserPalletStock.EditIntroText' | translate}}
  </p>
  <form [formGroup]="stockFormGroup" #documentFormDirective="ngForm">
    <div class="p-fluid formgrid grid" [ngClass]="{'mt-4': !isEdit}">
      <div class="field col-12 md:col-6 lg:col-6">
        <label for="stockName" class="font-semibold font-9rem">
          {{ isEdit ? ('UserPalletStock.NewStockNameTitle' | translate) : ('UserPalletStock.StockNameTitle' | translate) }} *
        </label>
        <input
          id="stockName"
          formControlName="stockName"
          type="text"
          required
          pInputText
          placeholder="Stock Name"
          class="custom-input"/>
        <small *ngIf="submitStockFile && stockFormGroup.controls['stockName'].invalid" class="p-error">{{getErrorMessage(stockFormGroup, 'stockName')}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-6">
        <label for="fridgeStorage" class="font-semibold font-9rem">
          {{'UserPalletStock.FridgeStorageSelectionTitle' | translate}}
        </label>
        <p-dropdown id="fridgeStorage"
          formControlName="fridgeStorageId"
          [options]="fridgeStorages"
          optionLabel="name"
          optionValue="id"
          [filter]="true"
          filterBy="name"
          [showClear]="true"
          placeholder="{{'UserPages.UserExportOffers.EditExportOffer.FridstorageFieldPlaceholder' | translate}}"
          emptyMessage="{{'UserPages.UserExportOffers.EditExportOffer.FridgestorageEmptyMessage' | translate}}"
          class="custom-dropdown">
        </p-dropdown>
        <small *ngIf="submitStockFile && stockFormGroup.controls['fridgeStorageId'].invalid" class="p-error">{{getErrorMessage(stockFormGroup, 'fridgeStorageId')}}</small>
      </div>
      <div class="field col-12 md:col-12 lg:col-12" *ngIf="formatPalletStock.length > 0">
        <label for="formatPalletStockId" class="font-semibold font-9rem">{{'UserPalletStock.FormatFileLabel' | translate}}*</label>
        <p-dropdown
          [options]="formatPalletStock"
          formControlName="formatPalletStockId"
          optionLabel="name"
          appendTo="body"
          placeholder="{{'UserPalletStock.FormatFileLabel' | translate}}"
          optionValue="id"
          class="custom-dropdown">
        </p-dropdown>
        <small *ngIf="submitStockFile && stockFormGroup.controls['formatPalletStockId'].invalid" class="p-error">{{getErrorMessage(stockFormGroup, 'formatPalletStockId')}}</small>
      </div>
      <div class="field col-12">
        <label class="text-sm line-height-2">
          {{'UserPages.UserExportOfferDocument.Form.LoadDocumentLabel' | translate}}
        </label>
        <p-fileUpload
          #documentFileUploader
          (onSelect)="onSelectDocumentFile($event)"
          (onClear)="onClearDocumentFile($event)"
          (onRemove)="onClearDocumentFile($event)"
          [showUploadButton]="false"
          [multiple]="false"
          accept=".xlsx"
          [maxFileSize]="fileMaxSize"
          [showCancelButton]="false"
          [files]="stockFile ? [stockFile] : []"
          class="file-uploader"
          [chooseLabel]="stockFile ?
            ('UserPages.UserExportOfferDocument.Form.EditFile' | translate) :
            ('UserPages.UserExportOfferDocument.Form.SelectFile' | translate)
          ">
          <ng-template let-file pTemplate="file">
            <div class="flex flex-row justify-content-between align-content-center align-items-center">
              <span>{{ file.name }}</span>
              <span>{{ file.size | number }} KB</span>
              <p-button
                label="{{'UserPalletStock.RemoveButtonLabel' | translate}}"
                icon="pi pi-times"
                class="custom-text-button danger-filled"
                (onClick)="documentFileUploader.remove(file, 0)"
              />
            </div>
          </ng-template>
        </p-fileUpload>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <p-button
      label="{{'UserPages.UserExportOfferDocument.Form.CancelButtonLabel' | translate}}"
      (onClick)="onCloseFileFormat()"
      styleClass="p-button-outlined"
      class="custom-text-button form-button"/>
    <p-button
      label="{{'UserPages.UserExportOfferDocument.Form.SaveButtonLabel' | translate}}"
      (onClick)="manageStock()"
      [loading]="loading"
      class="custom-text-button form-button"/>
  </ng-template>
</p-dialog>

<p-dialog
  header="" [(visible)]="visibleCreateFormatPalletStock"
  [style]="{width: '80vw', height: '90vh'}" class="stock-dialog"
  [modal]="true"
  [resizable]="false"
  [draggable]="false">

  <ng-template pTemplate="header">
    <div class="flex flex-row align-items-center gap-3">
      <span class="text-xl font-bold">{{'UserPalletStock.CreateFormatTitle' | translate}}</span>
      <div *ngIf="stockFile">
        <i class="pi pi-info-circle text-blue-600 cursor-pointer"
          (click)="instructionsOverlay.toggle($event)"
          pTooltip="{{'UserPalletStock.ClickHereInfoText' | translate}}"></i>
        <p-overlayPanel #instructionsOverlay>
          <ng-template pTemplate="content">
            <div class="flex flex-column text-sm text-justify">
              <span><strong>*</strong> {{'UserPalletStock.SelectColumnInfoText' | translate}}</span>
              <span><strong>*</strong> {{'UserPalletStock.EmptyColumnInfoText' | translate}}</span>
            </div>
          </ng-template>
        </p-overlayPanel>
      </div>
    </div>
  </ng-template>

  <div>
    <app-create-pallet-stock-format
      [headers]="headers"
      (OnCancelCreate)="onCancelCreateFormat()"
      (OnCreateFormat)="onSaveFormat()"
      [file]="stockFile"
      [formatName]="selectedStockName"
    >
    </app-create-pallet-stock-format>
  </div>
</p-dialog>

<p-dialog header=""
[(visible)]="visiblePalletStock"
[modal]="true"
  [style]="{width: '80%', height: '90vh'}" class="stock-detail-dialog">
  <ng-template pTemplate="header">
    <div class="flex flex-column">
      <span class="text-xl font-semibold">{{ selectedStockName ?? '' }}</span>
      <span class="text-xs text-gray-500">
        {{ 'UserPalletStock.CreationDate' | translate }}:
        {{ selectedStockCreated ? (selectedStockCreated | date:'dd/MM/yyyy') : '' }}
      </span>
    </div>
  </ng-template>

  <div class="flex flex-column" style="height: 100%;">
    <span class="text-sm font-medium">* {{ 'UserPalletStock.StockIntroText' | translate }}</span>
    <div style="flex-shrink: 0;" class="col-12">
      <app-filter-pallet-stock [stockId]="selectStockId" (applyFilterEvent)="configFilter($event)"></app-filter-pallet-stock>
    </div>

    <div class="flex-grow-1 overflow-hidden p-2">
      <p-table
        #palletStockTable
        [value]="palletStock"
        dataKey="rowData.id"
        [globalFilterFields]="['excelImportSpecies', 'excelImportVariety', 'excelImportContainerNumber', 'status']"
        [paginator]="true"
        [lazy]="true"
        (onLazyLoad)="getPalletStockPaged($event)"
        [rows]="pageSizePalletStock"
        [totalRecords]="totalCountPalletStock"
        [loading]="loadingPalleStock"
        [scrollable]="true"
        scrollHeight="flex"
        style="width: 100%; height: 100%;"
        class="custom-table order-table"
      >
        <ng-template pTemplate="header" >
          <tr>
            <th>
              <div class="cell-style">
                {{'UserPalletStock.StatusLabel' | translate}}
              </div>
            </th>
            <th>
              <div class="cell-style">
                {{'UserPalletStock.Program' | translate}}
              </div>
            </th>
            <th>
                <div class="cell-style">
                  {{'UserPalletStock.OrderId' | translate}}
                </div>
            </th>
            <th *ngFor="let col of stockColumns">
              <div class="cell-style">
                {{ col | stockColumn }}
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" >
          <tr>
              <td>
                <div *ngIf="rowData.status === 0" class="cell-style">
                  <span class="status-text stock-not-used">
                    {{'UserPalletStock.NotUsedStatus' | translate}}
                  </span>
                </div>
                <div *ngIf="rowData.status === 1" class="cell-style">
                  <span  class="status-text stock-used">
                    {{'UserPalletStock.UsedStatus' | translate}}
                  </span>
                </div>
                <div *ngIf="rowData.status === 2" class="cell-style">
                  <span  class="status-text stock-dispatch">
                    {{'UserPalletStock.DispatchStatus' | translate}}
                  </span>
                </div>
              </td>
              <td>
                <div  class="cell-style">
                  {{rowData.directSaleProgramId ? rowData.directSaleProgramId : 'UserPalletStock.NotAssigned' | translate }}
                </div>
              </td>
              <td><div  class="cell-style">
                {{rowData.importOrderSequence ? rowData.importOrderSequence : 'UserPalletStock.NotAssigned' | translate }}
              </div>
              </td>
              <td *ngFor="let col of stockColumns">
                <div  class="cell-style">
                  {{ rowData[col.frontEntityField] }}
                </div>
              </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-dialog>

<p-dialog header="{{'UserPalletStock.StockAlertTitle' | translate}}" [(visible)]="visibleAlerts" [modal]="true">

  <div class="body-card pt-3">
    <p-table
      [value]="stockAlerts"
      [paginator]="true"
      [rows]="10"
      [loading]="loadingAlert"
      class="custom-table"
    >
        <ng-template pTemplate="header">
          <tr>
              <th>
                <div class="flex justify-content-center">
                  {{'UserPalletStock.ContainerHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'UserPalletStock.AlertTypeHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'UserPalletStock.DescriptionHeader' | translate}}
                </div>
              </th>
              <th>
                <div class="flex justify-content-center">
                  {{'UserPalletStock.ReviewHeader' | translate}}
                </div>
              </th>
           </tr>
        </ng-template>

        <ng-template pTemplate="body" let-alert>
          <tr>
            <td>
              <div class="flex justify-content-center gap-3">
                {{alert.containerNumber}}
              </div>
            </td>
            <td>
              <div *ngIf="alert.type === 0" class="cell-style">
                <span  class="status-text stock-not-used">
                  {{'UserPalletStock.DuplicatedText' | translate}}
                </span>
              </div>
              <div *ngIf="alert.type === 1" class="cell-style">
                <span  class="status-text stock-not-used">
                  {{'UserPalletStock.UsedText' | translate}}
                </span>
              </div>
              <div *ngIf="alert.type === 2" class="cell-style">
                <span  class="status-text stock-not-used">
                  {{'UserPalletStock.MissingFieldsText' | translate}}
                </span>
              </div>
              <div *ngIf="alert.type === 3" class="cell-style">
                <span  class="status-text stock-not-used">
                  {{'UserPalletStock.DataNotFoundText' | translate}}
                </span>
              </div>
              <div *ngIf="alert.type === 4" class="cell-style">
                <span  class="status-text stock-not-used">
                  {{'UserPalletStock.NotAssignedText' | translate}}
                </span>
              </div>
              <div *ngIf="alert.type === 5" class="cell-style">
                <span  class="status-text stock-not-used">
                  {{'UserPalletStock.ReceiverNotAllowedText' | translate}}
                </span>
              </div>
            </td>
            <td>
              <div class="flex justify-content-center gap-3">
                {{alert.description}}
              </div>
            </td>
            <td>
              <div  class="flex justify-content-center gap-3">
                <p-checkbox
                  [(ngModel)]="alert.reviewed"
                  [binary]="true"
                  (onChange)="updateReviewed(alert.guid, $event)"
                >
                </p-checkbox>
              </div>
            </td>
          </tr>
        </ng-template>
    </p-table>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      label="{{'UserPages.UserExportOfferDocument.Form.CancelButtonLabel' | translate}}"
      (onClick)="visibleAlerts = false"
      styleClass="p-button-outlined"
      class="custom-text-button form-button"/>
  </ng-template>
</p-dialog>


<p-dialog header="{{'UserPalletStock.ConfigureQuarterText' | translate}}"
 [style]="{width: '50vw'}"
 class="stock-dialog"
[(visible)]="visibleQuarterNameConfig"
  [resizable]="false"
  [draggable]="false"
[modal]="true">
<div *ngIf="selectStockId && visibleQuarterNameConfig">
  <app-quarter-name-config-form  [stockId]="selectStockId">
  </app-quarter-name-config-form>
</div>

</p-dialog>

<p-dialog header="{{'UserPalletStock.StockStatsTitle' | translate}}"
 [style]="{width: '50vw'}"
  [(visible)]="visibleStats"
  [resizable]="false"
  [draggable]="false"
>
<div *ngIf="selectStock">
<app-stock-stats [stock]="selectStock">
</app-stock-stats>
</div>
</p-dialog>

<p-dialog header="{{'UserPalletStock.StockColumRuleTitle' | translate}}"
  [style]="{width: '80vw', height: '90vh'}" class="stock-dialog"
  [(visible)]="visibleRule"
    [resizable]="false"
    [draggable]="false"
>
  <div *ngIf="selectStock">
  <app-stock-column-rule [stock]="selectStock"></app-stock-column-rule>
  </div>
</p-dialog>

<p-dialog
[(visible)]="visibleProgramFromStock"
[style]="{width: '80vw', height: '90vh'}"
class="stock-dialog"
[resizable]="false"
[draggable]="false">
<div *ngIf="selectStock" style="height: 100%;">
  <app-program-from-stock-form [stockId]="selectStock.id"
  (OnCancelCreate)="onCancelCreateFromStock()"
  (OnCreateStock)="onCancelCreateFromStock()">
  </app-program-from-stock-form>
</div>
</p-dialog>
